import { gql } from '@apollo/client';
import { ALL_GOAL_FIELDS } from '../fragments/predictiveAudiences';

export const fetchPredictiveAudienceVocabularyQuery = gql`
  query getVocabulary {
    predictiveAudiencesVocabulary {
      customEvents {
        type
        deltaName
        displayName
        dataType
        userCount1Month
        userCount13Week
      }
      purchaseEvents {
        type
        deltaName
        displayName
        occurrencesDataType
        purchaseAmountDataType
        userCount1Month
        userCount13Week
      }
      systemEvents {
        type
        deltaName
        displayName
        dataType
        userCount1Month
        userCount13Week
      }
      userFeatures {
        type
        deltaName
        displayName
        dataType
        userCountMostRecent
        lastUsed
        values
      }
      durations {
        durations
        defaultDuration
      }
      computedFor
    }
  }
`;

export const fetchPredictiveAudienceGoalsQuery = gql`
  ${ALL_GOAL_FIELDS}
  query GetPredictiveAudienceGoals {
    predictiveAudienceGoals {
      ...AllGoalFields
    }
  }
`;

export const fetchPredictiveAudienceGoalsMinimalQuery = gql`
  query GetPredictiveAudienceGoals {
    predictiveAudienceGoals {
      id
    }
  }
`;

export const fetchPredictiveAudienceGoalQuery = gql`
  ${ALL_GOAL_FIELDS}
  query GetPredictiveAudienceGoal($id: Long!) {
    predictiveAudienceGoal(id: $id) {
      ...AllGoalFields
    }
  }
`;

export const fetchPredictiveGoalUsers = gql`
  fragment userInfo on User {
    id
    fullName
    avatarUrl
  }
  query GetPredictiveGoalUsers {
    users {
      ...userInfo
    }
  }
`;

export const fetchTopExplainableFeaturesByDirection = gql`
  query GetTopExplainableFeaturesByDirection($id: Long!, $direction: Direction!, $max: Int!) {
    predictiveAudienceGoalTopExplainableFeaturesInDirection(
      id: $id
      max: $max
      direction: $direction
    ) {
      name
      strength
      direction
      featureType
      constituentFeatures {
        name
        weight
      }
    }
  }
`;

export const fetchPreviewUsers = gql`
  query getPreviewUsersTotalCount($goal: Json!) {
    estimatePredictiveGoalUserCount(goal: $goal) {
      total_count
    }
  }
`;
